module.exports = __webpack_public_path__ + "img/marker-black.7a3a7341.svg";